module.exports = __webpack_public_path__ + "img/approved-budget.464d39dd.svg";